import { CognitoIdToken } from "@goodfill/backend-api-client";

const ENDPOINT_URL = `${
  import.meta.env.VITE_BACKEND_BASE_URL
}/customer-application/listBrokerEnumerations/businessesAndOccupations`;

/**
 * @see https://stackoverflow.com/a/41563966
 */
function csvToArray(text: string): string[][] {
  let p = "";
  let row = [""];
  const ret = [row];
  let i = 0;
  let r = 0;
  let s = !0;
  let l;
  for (l of text) {
    if ('"' === l) {
      if (s && l === p) {
        row[i] += l;
      }
      s = !s;
    } else if ("," === l && s) {
      l = row[++i] = "";
    } else if ("\n" === l && s) {
      if ("\r" === p) {
        row[i] = row[i].slice(0, -1);
      }
      row = ret[++r] = [(l = "")];
      i = 0;
    } else {
      row[i] += l;
    }
    p = l;
  }
  return ret;
}

export interface BusinessesAndOccupation {
  business: string;
  occupation: string;
}

export function parseBusinessAndOccupation(input: string): BusinessesAndOccupation {
  const result = csvToArray(input)[0];

  return {
    business: result[0],
    occupation: result[1],
  };
}

export async function listBusinessesAndOccupations(
  cognitoIdToken: CognitoIdToken,
): Promise<BusinessesAndOccupation[]> {
  const result = await fetch(`${ENDPOINT_URL}`, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${cognitoIdToken}`,
    },
  });

  if (result.status === 404) {
    return [];
  }

  return ((await result.json())["businessesAndOccupations"] as string[]).map(parseBusinessAndOccupation);
}
